import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import LoadingAssignmentContainer from '../../containers/logistics/LoadingAssignment';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';

import ResourceUploader from '../../components/form/ResourceUploader';
import FMPSelect from '../../components/pureForm/FMPSelect';
import FormComponent from '../../components/FormComponent';
import { post } from '../../modules/utility';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import FMPSubmitButton from '../../components/form/FMPSubmitButton';
import FMPText from '../../components/pureForm/FMPText';
import SaveRetailPriceParseResults from '../../components/Dialogs/SaveRetailPriceParseResults';

const styles = (theme) => {
	return {
		tabSection: {
			backgroundColor: theme.palette.background.paper,
			width: '100%',
		},
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		pickPlease: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#666',
		},
	};
};

class ImportRetailPricing extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			daysToLockPrice: 7,
			isDialogOpen: false,
		};
	}

	handleDataFileUpload = ({ resource }) => {
		this.setState({ dataFileResourceId: resource.resourceId });
	};

	handleSave = () => {
		const { showErrors } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const { source, dataFileResourceId, textChunk } = this.state;

		const params = { source };
		if (source === 'g&m' || source === 'pearsonBulk') {
			params.resourceId = dataFileResourceId;
		} else {
			params.textChunk = textChunk;
		}

		post({
			method: 'retailPrice.parse',
			params,
			callback: (err, apiParseResults) => {
				if (err) {
					showErrors(err);
				}
				this.setState({ isDialogOpen: true, apiParseResults });
			},
		});
	};

	handleCloseDialog = () => {
		this.setState({
			isDialogOpen: false,
			apiParseResults: undefined,
		});
	};

	render() {
		const { classes } = this.props;
		const { apiParseResults } = this.state;

		const optionsForDaysToLockPrice = [];
		const dayList = _.range(0, 10);
		dayList.push(10, 15, 20, 30, 31, 60, 90, 120);

		dayList.forEach((x) => {
			if (x === 0) {
				optionsForDaysToLockPrice.push({ value: x, display: `No Lock` });
			} else {
				optionsForDaysToLockPrice.push({ value: x, display: `Lock for ${x} days` });
			}
		});

		const { source } = this.state;
		return (
			<Paper className={classes.paper}>
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<Grid container spacing={2}>
							<Grid item xs={12} md={12}>
								<FMPRegionHeader isTop={true} label={'Import Retail Pricing'} />
							</Grid>

							<Grid item xs={12} md={12}>
								<FMPSectionHeader label="Customer" />
							</Grid>

							<FMPSelect
								{...this.setForm('source', 'Source')}
								options={[
									{ value: 'g&m', display: 'G&M' },
									{ value: 'h&s', display: 'H&S' },
									{ value: 'pearsonBulk', display: 'Pearson List' },
								]}
							/>

							<FMPSelect
								{...this.setForm('daysToLockPrice', 'Days To Lock Price')}
								helpText={'Locked prices can not be overridden by GasBuddy'}
								options={optionsForDaysToLockPrice}
							/>

							<Grid item xs={12} md={12}>
								<FMPSectionHeader label="Data" />
							</Grid>
							{!source && this.renderPickPlease()}
							{(source === 'g&m' || source === 'pearsonBulk') && this.renderFileUpload()}
							{source === 'h&s' && this.renderTextChunk()}

							<FMPSubmitButton
								onClick={this.handleSave}
								buttonText={`Parse and Check`}
								isDisabled={!source}
							/>
						</Grid>
					</Grid>
				</Grid>

				<SaveRetailPriceParseResults
					open={this.state.isDialogOpen}
					daysToLockPrice={this.state.daysToLockPrice}
					onClose={this.handleCloseDialog}
					apiParseResults={apiParseResults}
				/>
			</Paper>
		);
	}

	renderPickPlease = () => {
		const { classes } = this.props;
		return (
			<Grid item xs={12} md={12}>
				<div className={classes.pickPlease}>
					Please select a source first from the dropdown above
				</div>
			</Grid>
		);
	};

	renderFileUpload = () => {
		const { resourceMap, classes } = this.props;
		const { dataFileResourceId, source } = this.state;

		let resource;
		if (dataFileResourceId) {
			resource = resourceMap[dataFileResourceId];
			/** @namespace resource.contentType **/
			resource.isCsv = !!resource.contentType.match(/(csv)/);
		}

		return (
			<Grid item xs={12} md={12}>
				{source === 'pearsonBulk' && (
					<Grid container spacing={3} style={{ marginTop: 10 }}>
						<Grid item xs={12} md={12}>
							<div className={classes.pickPlease}>
								Reminder: Pearson List format is a CSV with two columns: Station number (R001) and
								price (2.999). CSV should contain a header row: Station Number, Price
							</div>
						</Grid>
					</Grid>
				)}

				{!!resource && (
					<Grid container spacing={3} style={{ marginTop: 10 }}>
						<Grid item xs={11} md={4}>
							{resource.isCsv && (
								<div>
									<span role="img" aria-label="success">
										✅
									</span>
									File uploaded and CSV detected
								</div>
							)}
							{!resource.isCsv && (
								<div>
									<span role="img" aria-label="warning">
										⚠️
									</span>
									File uploaded but was not a valid CSV file.
								</div>
							)}
						</Grid>
						<Grid item xs={11} md={4}>
							{resource.contentType}
						</Grid>
					</Grid>
				)}

				<ResourceUploader
					name={'dataFileResourceId'}
					label={'Upload CSV File'}
					afterUpload={this.handleDataFileUpload}
					onlyOne={true}
				/>
			</Grid>
		);
	};

	renderTextChunk = () => {
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPText {...this.setForm('textChunk', 'Text chunk from email')} multiline={20} />
				</Grid>
			</Grid>
		);
	};
}

ImportRetailPricing.propTypes = {
	resourceMap: PropTypes.object,
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	LoadingAssignmentContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
])(ImportRetailPricing);
